// src/redux/thunks/fetchEvents.js

import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const MANAGER_API = process.env.REACT_APP_MANAGER_API;

export const fetchEvents = createAsyncThunk(
  'home/fetchEvents',
  async (token, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const selectedMonthName = state.home.selectedMonthName;
      const selectedYear = state.home.selectedYear;

      const params = new URLSearchParams({
        month: String(selectedMonthName),
        year: String(selectedYear),
        my_assignments: 'true',
        limit: '200',
      });

      const response = await axios.get(
        `${MANAGER_API}/api/v1/events/?${params}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const raw = response.data?.data || [];

      // Map Manager BE field names → legacy field names used by EventCard/Home
      const data = raw.map((e) => ({
        event_id: e.id,
        event_code: e.code || '',
        event_name: e.name || '',
        event_location: e.location || '',
        event_date_start: e.date_start || '',
        event_date_finish: e.date_finish || '',
        event_time_start: e.time_start || '',
        event_time_finish: e.time_finish || '',
        event_group_id: e.event_group_id,
        event_group_name: e.event_group_name || '',
        event_group_event_type: e.event_group_event_type || '',
        event_group_event_logo: e.event_group_event_logo || '',
        event_pic_event: e.pic_event || '',
        event_team_a_id: e.team_a_id,
        event_team_b_id: e.team_b_id,
        event_cover_image: e.cover_image || '',
        event_link_media: e.link_media || '',
        team_a_name: e.team_a_name || '',
        team_b_name: e.team_b_name || '',
        team_a_id: e.team_a_id,
        team_b_id: e.team_b_id,
      }));

      return { DATA: data, ERROR: null };
    } catch (error) {
      const msg = error.response?.data?.detail || error.response?.data?.message || error.message;
      return rejectWithValue({ error: msg });
    }
  }
);
